(() => {
  function setup(root) {
    if (root.dataset.dtdBound === 'true') return;
    root.dataset.dtdBound = 'true';

    const tabs = Array.from(root.querySelectorAll('.dtd-day__tab'));
    const panel = root.querySelector('.dtd-day__result');
    if (!tabs.length || !panel) return;

    function choose(tab) {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      panel.dataset.scene = tab.dataset.scene;
      panel.setAttribute('aria-labelledby', tab.id);
      panel.querySelector('[data-dtd-time]').textContent = `${tab.dataset.time} / ${tab.dataset.label}`;
      panel.querySelector('[data-dtd-heading]').textContent = tab.dataset.heading;
      panel.querySelector('[data-dtd-copy]').textContent = tab.dataset.copy;
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => choose(tab));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        choose(tabs[next]);
        tabs[next].focus();
      });
    });

    root.addEventListener('shopify:block:select', (event) => {
      const tab = event.target.closest('.dtd-day__tab');
      if (tab && root.contains(tab)) choose(tab);
    });
  }

  function setupAll(scope) {
    scope.querySelectorAll('[data-dtd-home]').forEach(setup);
  }

  setupAll(document);
  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();
